import styles from './HeroContainer.module.scss';

export const HeroContainer = () => {
    return (
        <div className={styles['hero-container']}>
            <div className={styles['black-bg']}>
                <div className={styles['full-frame-hero']} id="home">
                    <div className={styles['headline']}>
                        <p className={styles['title']}>Thrive in a Regulated Market with Confidence</p>
                        <p className={styles['subtitle']}>Legal Expertise for Alcohol and Cannabis Innovators</p>
                    </div>
                </div>
                <div className={styles['bottom-row-container']}>
                    {/*<div className={styles['bottom-row']}>*/}
                        {/*<div className={styles['card1']}>*/}
                        {/*    <div className={styles['content-wrapper']}>*/}
                        {/*        <p>Amet turpis cursus tincidunt dignissim gravida etiam turpis. Auctor morbi convallis*/}
                        {/*            amet*/}
                        {/*            sit integer. Dui sit lacus fames et proin ultrices erat.</p>*/}
                        {/*        <p>— Marsha Barrows</p>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className={styles['card2']}>*/}
                        {/*    <div className={styles['content-wrapper']}>*/}
                        {/*        <p>Faucibus sed nunc non orci id. Ac magna quis consequat ut nulla urna netus sit.</p>*/}
                        {/*        <p>— Don Hackett</p>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                    {/*</div>*/}
                    {/*<div className={styles['bottom-row-footer']}>*/}
                    {/*    <div className={styles['card3']}>*/}
                    {/*        <div className={styles['content-wrapper']}>*/}
                    {/*            <div className={styles['copy-wrapper']}>*/}
                    {/*                <div className={styles['frame']}>*/}
                    {/*                    <div className={styles['date-wrapper']}>*/}
                    {/*                        <p>Featured Article</p>*/}
                    {/*                        <p>OCT 7, 2022 3 MIN READ</p>*/}
                    {/*                    </div>*/}
                    {/*                    <p>President Biden just made a big cannabis announcement... what does it mean?</p>*/}
                    {/*                </div>*/}

                    {/*            </div>*/}
                    {/*            <div className={styles['button-wrapper']}>*/}
                    {/*            /!*    TODO: add button*!/*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}

                    {/*</div>*/}
                </div>
            </div>
        </div>
    )
}
